var map = {
	"./8pay-network.json": 29845,
	"./alchemy-pay.json": 88095,
	"./alien-worlds.json": 2539,
	"./alpaca-finance.json": 25047,
	"./alphatoken.json": 47381,
	"./ambire-adex.json": 64272,
	"./ampleforth.json": 89748,
	"./ankr.json": 36510,
	"./apenft.json": 78988,
	"./apollox.json": 88027,
	"./ariva.json": 6846,
	"./arpa.json": 57926,
	"./automata.json": 24478,
	"./axie-infinity.json": 2374,
	"./bakeryswap.json": 85705,
	"./beefy-finance.json": 14120,
	"./bella-protocol.json": 20895,
	"./belt.json": 68373,
	"./beta-finance.json": 64952,
	"./binamon.json": 86198,
	"./binance-pegged-busd.json": 27310,
	"./binance-pegged-dai.json": 27575,
	"./binance-pegged-usd-coin.json": 81301,
	"./binance-pegged-usdt.json": 29754,
	"./biswap.json": 89473,
	"./boringdao.json": 8659,
	"./bscpad.json": 36591,
	"./bux.json": 95996,
	"./carbon-protocol.json": 50043,
	"./ceek.json": 49569,
	"./chainguardians.json": 83847,
	"./chainlink.json": 47503,
	"./chromia.json": 17077,
	"./coin98.json": 29750,
	"./compound-finance.json": 24317,
	"./corite.json": 84843,
	"./cosmos.json": 12943,
	"./cryptoblades-skill.json": 39802,
	"./decentral-games.json": 69211,
	"./deri.json": 63804,
	"./dexe.json": 1969,
	"./dodo.json": 53478,
	"./dogelon-mars.json": 82114,
	"./ellipsis.json": 46350,
	"./ertha.json": 77388,
	"./exeedme.json": 63484,
	"./fc-lazio-fan.json": 29787,
	"./fc-santos-fan.json": 46422,
	"./forj.json": 31379,
	"./fortube.json": 24444,
	"./frontier.json": 20663,
	"./froyo.json": 91869,
	"./fuse.json": 41795,
	"./galactic-quadrant.json": 34370,
	"./galxe.json": 23512,
	"./gamee.json": 89266,
	"./hacken.json": 57114,
	"./hashflow.json": 25431,
	"./hay-destablecoin.json": 47789,
	"./hook.json": 13550,
	"./horizon-protocol.json": 91406,
	"./hot-cross.json": 65995,
	"./impossible-decentralized-incubator.json": 72998,
	"./injective-protocol.json": 65454,
	"./insur.json": 33982,
	"./juggernaut-finance.json": 87620,
	"./kalmar.json": 78847,
	"./kattana.json": 91338,
	"./league-of-ancients.json": 18629,
	"./linear-finance.json": 46714,
	"./lto-network.json": 45644,
	"./mars-ecosystem.json": 35128,
	"./mask-network.json": 32594,
	"./math.json": 91891,
	"./mcdex.json": 62700,
	"./meta-apes-peel.json": 35612,
	"./metahero.json": 70352,
	"./meter.json": 56917,
	"./metis.json": 60068,
	"./mettalex.json": 13724,
	"./mirror-finance.json": 6126,
	"./mixmarvel.json": 92083,
	"./mobox.json": 93161,
	"./monsta-infinite.json": 78925,
	"./my-neighbor-alice.json": 69311,
	"./nabox.json": 13290,
	"./nanobyte.json": 35679,
	"./naos-finance.json": 33203,
	"./nerve-finance.json": 56131,
	"./o3-swap.json": 53019,
	"./oddz.json": 3445,
	"./onyxcoin.json": 36568,
	"./pancakeswap.json": 25439,
	"./peakdefi.json": 75729,
	"./peardao.json": 16646,
	"./pnt.json": 82378,
	"./polkamon.json": 53593,
	"./polycrowns.json": 1612,
	"./prometeus.json": 33916,
	"./prosper.json": 62791,
	"./pstake-finance.json": 85078,
	"./quidd.json": 45640,
	"./radio-caca-v2.json": 29287,
	"./ramp-defi.json": 99031,
	"./rangers-protocol.json": 34671,
	"./reef.json": 75854,
	"./refinable.json": 45228,
	"./renbtc.json": 91555,
	"./revv.json": 91697,
	"./rfox.json": 65926,
	"./safepal.json": 54373,
	"./seedify-fund.json": 50082,
	"./singularity-dao.json": 60844,
	"./spartan-protocol.json": 92982,
	"./splintershards.json": 22334,
	"./standard-btc-hashrate-token.json": 5874,
	"./stepn-gmt.json": 19666,
	"./sushi.json": 11627,
	"./swingby.json": 18248,
	"./swipe.json": 20408,
	"./the-orbs-network.json": 59158,
	"./tixl.json": 40535,
	"./token-squad.json": 32572,
	"./tokenpocket.json": 12155,
	"./tokocrypto.json": 21419,
	"./tranchess.json": 91662,
	"./true-usd.json": 81910,
	"./trust-wallet.json": 38762,
	"./unifi.json": 39606,
	"./uniswap.json": 56186,
	"./unmarshal.json": 28604,
	"./vai-stablecoin.json": 27608,
	"./venus.json": 87238,
	"./wall-street-games.json": 59347,
	"./waultswap.json": 10734,
	"./wombat.json": 32872,
	"./wombex.json": 50463,
	"./woo-network.json": 69233,
	"./woonkly-power.json": 61996,
	"./wrapped-bnb.json": 49789,
	"./xend.json": 20740,
	"./yel.json": 71980,
	"./zeroswaptoken.json": 98421,
	"./zilliqa.json": 53878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98296;